'use strict';

let codes = Object.freeze({
    NOT_FOUND                      : 'storageApiService.fileNotFound',
    SPACE_QUOTA                    : 'storageApiService.exceededSpaceQuota',
    CONTENT_TYPE                   : 'storageApiService.invalidContentType',
    METADATA                       : 'storageApiService.invalidMetadata',
    FILE_SIZE                      : 'storageApiService.exceededFileSize',
    PARTS_NUMBER                   : 'storageApiService.exceededPartsAmount',
    FILES_NUMBER                   : 'storageApiService.exceededFilesNumber',
    FIELDS_NUMBER                  : 'storageApiService.exceededFieldsNumber',
    UPLOAD                         : 'storageApiService.uploadError',
    STORAGE                        : 'storageApiService.storageError',
    DATABASE                       : 'storageApiService.databaseError',
    ACCESS_DENIED                  : 'storageApiService.accessDenied',
    NO_FILE                        : 'storageApiService.noFile',
    UNSUPPORTED_FILE_TYPE          : 'storageApiService.unsupportedFileType',
    NOT_DELETED                    : 'storageApiService.fileNotDeleted',
    NOT_FOUND_IN_STORAGE           : 'storageApiService.fileNotFoundInStorage',
    REMOVED_FROM_STORAGE           : 'storageApiService.fileRemovedFromStorage',
    PROFILE_EXISTS                 : 'storageApiService.profileExists',
    PROFILE_NOT_FOUND              : 'storageApiService.profileNotFound',
    SPACE_EXISTS                   : 'storageApiService.spaceExists',
    SPACE_NOT_FOUND                : 'storageApiService.spaceNotFound',
    USER_NOT_FOUND                 : 'storageApiService.userNotFound',
    USER_SPACE_NOT_FOUND           : 'storageApiService.userSpaceNotFound',
    SCOPE_OUT_OF_RANGE             : 'storageApiService.scopeOutOfRange',
    FILE_TYPE_NOT_ALLOWED          : 'storageApiService.fileTypeNotAllowed',    
    USER_EXCEEDED_SPACE_QUOTA_LIMIT: 'storageApiService.userExceededSpaceQuotaLimit',
    USER_EXCEEDED_FILE_NUMBER_LIMIT: 'storageApiService.userExceededFileNumberLimit',
    INVALID_MANIFEST               :'storageApiService.invalidManifest',
    UNSUPPORTED_ZIP_VERSION        : 'storageApiService.unsupportedZipVersion'
});

module.exports = codes;